import { Component, h, Host, Prop } from '@stencil/core';
import { ButtonAppearance, ButtonSize, ButtonStyle, ButtonControlValues } from './types';

/*** buttons with controls could be only green, for now ***/
@Component({
  tag: 'rentware-button',
  styleUrl: 'style.sass',
  shadow: false,
})
export class RentwareButton {
  @Prop() buttonText: string | Node;
  @Prop() buttonId?: string;
  @Prop() onClick: () => void;
  @Prop() appearance: ButtonAppearance = {};
  @Prop() controlValues: ButtonControlValues = null;
  @Prop() isWaiting: boolean = false;

  get buttonStyle(): ButtonAppearance {
    return {
      style: ButtonStyle.Default,
      size: ButtonSize.L,
      fullWidth: false,
      ...this.appearance,
    };
  }

  get classCSS(): string {
    const appearance = this.buttonStyle.style + 'Button ';
    const size = this.buttonStyle.size + ' ';
    const fullWidth = this.buttonStyle.fullWidth ? 'FullWidth ' : '';
    const noShadow = this.buttonStyle.noShadow ? 'NoShadow ' : '';
    return 'RentwareButton ' + appearance + size + fullWidth + noShadow;
  }

  get innerClass() {
    const appearance = this.buttonStyle.style + 'Button ' + this.buttonStyle.style + 'ButtonActive ';
    const disabled = this.buttonStyle.disabled ? 'DisabledButton ' : 'ActiveButton ';
    const isSmall = this.buttonStyle.size === ButtonSize.S ? 'ButtonInnerClickableAreaSmall' : '';
    return 'ButtonInnerClickableArea GradientButton ' + appearance + disabled + isSmall;
  }

  get tabIndex() {
    return this.buttonInactive ? -1 : 0;
  }

  get onClickCallback() {
    return this.buttonInactive ? null : this.onClick;
  }

  get buttonInactive() {
    return this.isWaiting || this.buttonStyle.disabled;
  }

  render() {
    return (
      <Host class={this.classCSS} id={this.buttonId}>
        {!!this.controlValues && this.controlValues?.maxQuantity > 1 && <rentware-button-controls controlValues={this.controlValues} appearance={this.buttonStyle} />}

        <div class={this.innerClass} onClick={this.onClickCallback} tabindex={this.tabIndex}>
          <div class="ButtonText">{this.buttonText}</div>
        </div>

        {this.buttonInactive && <div class={{ ButtonDisabled: true, ButtonWaiting: this.isWaiting }} />}
      </Host>
    );
  }
}
